var render = function render(){
  var _vm$payload$applicati, _vm$payload$applicati2, _vm$payload$applicati3, _vm$payload$applicati4;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form popup",
    on: {
      "dragover": _vm.dragover,
      "dragleave": _vm.dragleave
    }
  }, [_c('div', {
    staticClass: "pdf-section"
  }, [!_vm.loadingPdf && _vm.sourcePdf ? _c('div', {
    staticClass: "pdf-viewer"
  }, [_vm.documentTabs.length > 1 ? _c('div', {
    staticClass: "application-document-tabs",
    attrs: {
      "role": "tablist",
      "aria-label": "Dokumenty k žiadosti"
    }
  }, _vm._l(_vm.documentTabs, function (document) {
    return _c('button', {
      key: document.id,
      staticClass: "application-document-tab",
      "class": {
        active: document.id === _vm.activeDocumentId
      },
      attrs: {
        "type": "button",
        "role": "tab",
        "aria-selected": document.id === _vm.activeDocumentId,
        "title": document.label
      },
      on: {
        "click": function click($event) {
          return _vm.selectDocumentTab(document);
        }
      }
    }, [_vm._v(" " + _vm._s(document.label) + " ")]);
  }), 0) : _vm._e(), _vm.aiTemplateAvailable ? _c('div', {
    staticClass: "ai-generation-bar",
    "class": {
      completed: _vm.aiGenerated
    }
  }, [_c('div', {
    staticClass: "ai-generation-copy"
  }, [_c('span', {
    staticClass: "ai-sparkle",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("✦")]), _c('div', [_c('strong', [_vm._v(_vm._s(_vm.aiGenerated ? "AI návrh je pripravený" : "Vyplniť žiadosť pomocou AI"))]), _c('span', [_vm._v(" " + _vm._s(_vm.aiGenerated ? "".concat(_vm.aiFilledCount, " bezpe\u010Dne doplnen\xFDch pol\xED, dokument ost\xE1va editovate\u013En\xFD.") : "GPT použije údaje zo žiadosti, klientov, príjmov a nehnuteľností.") + " ")])])]), _c('button', {
    staticClass: "ai-generate-button",
    attrs: {
      "type": "button",
      "disabled": _vm.aiGenerating
    },
    on: {
      "click": _vm.generateWithAi
    }
  }, [_vm.aiGenerating ? _c('span', {
    staticClass: "ai-button-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("✦")]), _vm._v(" " + _vm._s(_vm.aiGenerating ? "Vypĺňam..." : _vm.aiGenerated ? "Vygenerovať znova" : "Generovať žiadosť") + " ")])]) : _vm._e(), _c('div', {
    staticClass: "pdf-canvas"
  }, [_vm.aiGeneratedPdfBlob ? _c('application-pdf-editor', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeDocumentId === 'ai-generated-application',
      expression: "activeDocumentId === 'ai-generated-application'"
    }],
    key: _vm.aiEditorVersion,
    ref: "aiPdfEditor",
    attrs: {
      "pdf-blob": _vm.aiGeneratedPdfBlob
    },
    on: {
      "ready": function ready($event) {
        _vm.aiEditorReady = true;
      },
      "dirty": function dirty($event) {
        _vm.aiEditorDirty = true;
      },
      "error": _vm.onAiEditorError
    }
  }) : _vm._e(), _c('iframe', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeDocumentId !== 'ai-generated-application',
      expression: "activeDocumentId !== 'ai-generated-application'"
    }],
    key: _vm.activeDocumentId,
    attrs: {
      "id": "iframepdf",
      "src": _vm.sourcePdf,
      "title": "Náhľad a editácia žiadosti"
    }
  }), _c('transition', {
    attrs: {
      "name": "ai-overlay"
    }
  }, [_vm.aiGenerating ? _c('div', {
    staticClass: "ai-loading-overlay",
    attrs: {
      "role": "status",
      "aria-live": "polite"
    }
  }, [_c('div', {
    staticClass: "ai-orbit",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "ai-orbit-ring"
  }), _c('span', {
    staticClass: "ai-orbit-sparkle"
  }, [_vm._v("✦")])]), _c('strong', [_vm._v("GPT vypĺňa žiadosť")]), _c('span', [_vm._v(_vm._s(_vm.aiLoadingMessage))]), _c('div', {
    staticClass: "ai-loading-dots",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('i'), _c('i'), _c('i')])]) : _vm._e()])], 1)]) : !_vm.loadingPdf && !_vm.sourcePdf ? _c('div', {
    staticClass: "no-pdf-link"
  }, [_c('img', {
    attrs: {
      "src": require("@/images/no-generated-pdf-image.svg"),
      "alt": ""
    }
  }), _c('div', [_vm._v(" v prípade tejto banky je potrebné žiadosť "), _c('br'), _vm._v(" zadať "), _c('a', {
    staticClass: "bold",
    attrs: {
      "href": _vm.getLinkToApplication((_vm$payload$applicati = _vm.payload.application) === null || _vm$payload$applicati === void 0 ? void 0 : (_vm$payload$applicati2 = _vm$payload$applicati.bank) === null || _vm$payload$applicati2 === void 0 ? void 0 : _vm$payload$applicati2.code_name),
      "target": "_blank"
    }
  }, [_vm._v("online TU")]), _vm._v(", vygenerovanú žiadosť "), _c('br'), _vm._v("online nezabudnite nahrať hore vpravo ")])]) : _c('div', {
    staticClass: "d-flex justify-content-center align-items-center h-100 w-100"
  }, [_c('v-progress-circular', {
    staticClass: "loading-spinner",
    attrs: {
      "indeterminate": ""
    }
  })], 1)]), _c('div', {
    staticClass: "infomation-section"
  }, [_c('div', {
    staticClass: "content-form-popup"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('div', {
    staticClass: "back-button-wrapper pointer",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "blackcolor pop-800"
  }, [_vm._v("Vygenerovanie žiadosti")]), _c('button', {
    staticClass: "w-button",
    attrs: {
      "disabled": !_vm.canSavePdf || _vm.savingPdf
    },
    on: {
      "click": _vm.savePdfToCloud
    }
  }, [_vm._v(" " + _vm._s(_vm.savingPdf ? "Ukladám..." : "Uložiť") + " ")])]), _c('div', {
    staticClass: "information-wrapper"
  }, [_c('div', {
    staticClass: "header-wrapper-custom"
  }, [_c('img', {
    attrs: {
      "src": (_vm$payload$applicati3 = _vm.payload.application) === null || _vm$payload$applicati3 === void 0 ? void 0 : (_vm$payload$applicati4 = _vm$payload$applicati3.bank) === null || _vm$payload$applicati4 === void 0 ? void 0 : _vm$payload$applicati4.logo_square,
      "alt": "",
      "width": "50px",
      "height": "auto"
    }
  }), _c('div', {
    staticClass: "p-12 bg-gray-100 border border-gray-300",
    on: {
      "drop": _vm.drop
    }
  }, [_c('input', {
    ref: "file",
    attrs: {
      "type": "file",
      "name": "vygenerovana-ziadost",
      "id": "vygenerovana-ziadost",
      "accept": ".pdf"
    },
    on: {
      "change": _vm.onChange
    }
  }), _c('label', {
    staticClass: "sub-ctass image-upload-btn add-file-button pointer blc-color pop-800 mb-0 drag-drop-label",
    attrs: {
      "for": "vygenerovana-ziadost"
    }
  }, [_vm._v(" " + _vm._s(_vm.filelist.length === 0 ? "+vyplnená žiadosť" : _vm.filelist[0].name) + " ")])])])]), _vm.aiGenerated ? _c('div', {
    staticClass: "ai-edit-hint"
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("✓")]), _c('div', [_c('strong', [_vm._v("Skontrolujte a upravte doplnené údaje")]), _c('p', [_vm._v(" PDF je editovateľné priamo. Tlačidlo „Uložiť“ uloží aktuálnu verziu vrátane všetkých vašich zmien. ")]), _vm.aiMissingCount ? _c('small', [_vm._v(" " + _vm._s(_vm.aiMissingCount) + " dôležitých údajov ostalo na ručné doplnenie. ")]) : _vm._e(), _vm.aiMappedCount ? _c('small', [_vm._v(" " + _vm._s(_vm.aiMappedCount) + " polí bolo vyplnených overeným bankovým mapovaním. ")]) : _vm._e(), _vm.aiReviewRequiredCount ? _c('small', [_vm._v(" " + _vm._s(_vm.aiReviewRequiredCount) + " neistých návrhov sa automaticky nezapísalo. ")]) : _vm._e()])]) : _vm.aiError ? _c('div', {
    staticClass: "ai-error-hint"
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("!")]), _c('div', [_vm._v(_vm._s(_vm.aiError))])]) : _vm._e(), _c('div', {
    staticClass: "cloud-holder-wrapper"
  }, [_c('mortgage-summary', {
    attrs: {
      "summary-data": _vm.payload.application
    }
  })], 1), _c('client-section', {
    attrs: {
      "client-data": _vm.applicantData,
      "role": 'Žiadateľ',
      "opened-default": _vm.opened
    }
  }), _vm.coApplicantData.clientObject ? _c('client-section', {
    attrs: {
      "client-data": _vm.coApplicantData,
      "role": 'Spolužiadateľ',
      "opened-default": _vm.opened
    }
  }) : _vm._e(), _vm._l(_vm.foundedPropertiesData, function (property, index) {
    return _c('div', {
      key: index + 'founded',
      staticClass: "cloud-holder-wrapper"
    }, [_c('property-summary', {
      attrs: {
        "summary-data": property,
        "label": "Zabezpe\u010Denie \xFAveru ".concat(index + 1),
        "opened-default": _vm.opened
      }
    })], 1);
  }), _vm._l(_vm.financedPropertiesData, function (property, index) {
    return _c('div', {
      key: index + 'financed',
      staticClass: "cloud-holder-wrapper"
    }, [_c('property-summary', {
      attrs: {
        "summary-data": property,
        "label": "Predmet nadob\xFAdania ".concat(index + 1),
        "opened-default": _vm.opened
      }
    })], 1);
  })], 2)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }